export default {
    title: "Store Verification",
    subtitle: "When you submit this form our moderators will check your data and confirm verified status.",
    back: "Back",
    address: {
        title: "Company address",
        city: {
            title: "City",
            placeholder: "Choose city"
        },
        street: {
            title: "Street",
            placeholder: "Street name"
        },
        number: {
            title: "Number",
            placeholder: "###"
        }
    },
    authorizedPerson: {
        title: "Authorized person",
        name: {
            title: "Name",
            placeholder: "Enter name"
        },

        surname: {
            title: "Surname",
            placeholder: "Enter surname"
        },

        idCard: {
            title: "ID card number",
            placeholder: "###"
        },
    },
    companyDetails: {
        title: "Company details",
        vat: {
            title: "VAT",
            placeholder: "Enter VAT"
        },
        pib: {
            title: "PIB",
            placeholder: "Enter PIB"
        },
        revenue: {
            title: "Last year revenue",
            placeholder: "###"
        }

    },
    verifyButton: "Verify",
    successMessage: "Store has been verified successfully."
}
